import type { StateCreator } from 'zustand';
import type { IInput } from '@/types';

import type { InputsSlice } from './types';

export type { InputsSlice } from './types';

export const inputsInitialState = {
  inputs: [] as IInput[],
};

export const createInputsSlice: StateCreator<
  InputsSlice,
  [],
  [],
  InputsSlice
> = (set) => ({
  ...inputsInitialState,

  setInputs: (inputs) => set({ inputs }),

  updateInput: ({ id, value }) =>
    set((state) => ({
      inputs: state.inputs.map((input) =>
        input.id === id ? ({ ...input, ...value } as IInput) : input
      ),
    })),
});
